import Bad from './bad'
import Good from './good'

export default {
  Bad,
  Good,
}
